(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2465],{

/***/ 31709:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketplace",
      function () {
        return __webpack_require__(24039);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 76688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(186);
/* harmony import */ var hooks_useTheme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63850);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62077);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(83468);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0px 16px;\n  transition: border-radius 0.15s;\n  color: #fdb533;\n  > svg {\n    fill: #fff !important;\n  }\n\n  @media screen and (max-width: 600px) {\n    padding: 0 10px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 180px;\n  height: 100%;\n  max-height:250px;\n  padding: 12px;\n  position: absolute;\n  overflow-y: hidden;\n  overflow-x:hidden;\n  z-index: ",
        ";\n  transition: transform 0.15s, opacity 0.15s;\n  transform: scaleY(0);\n  transform-origin: top;\n  opacity: 0;\n  box-sizing: border-box;\n  box-shadow: inset 0px -2px 4px rgba(255, 255, 255, 0.16), inset 4px 3px 3px rgba(0, 0, 0, 0.28);\n  border-radius: 10px;\n  background: ",
        ";\n  color: ",
        " !important;\n  ",
        " {\n    min-width: 50px;\n    width: 160px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        " {\n        /* box-shadow: ",
        "; */\n      }\n\n      ",
        " {\n        height: auto;\n        transform: scaleY(1);\n        opacity: 1;\n        border-top-width: 0;\n        box-shadow: ",
        ";\n        width: 100%;\n        background: #ffffff;\n        top: 49px;\n        border-radius: 8px;\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  width: ",
        "px;\n  position: relative;\n  width: 220px;\n  height: 48px;\n  box-sizing: border-box;\n  @media only screen and (max-width: 600px) {\n    width: 160px;\n  }\n  ",
        " {\n    // border-right: 0.15px solid rgba(151, 151, 151, 0.69);\n  }\n\n  border: 2px solid #e6e8ec;\n  border-radius: 12px;\n\n  ",
        " {\n    min-width: 100px;\n  }\n\n  ",
        "\n\n  svg {\n    position: absolute;\n    right: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n    fill: #fdb533 !important;\n  }\n  @media only screen and (max-width: 600px) {\n    width: 100%;\n    margin-top:1rem;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  z-index: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  list-style: none;\n  padding: 8px 16px;\n  border-radius:6px;\n  &:hover {\n    background: #ff592c;\n    > div {\n      color: #fff !important;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @media screen and (max-width: 320px) {\n    padding: 0px\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}





var DropDownHeader = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7363816c-0"
})(_templateObject());
var DropDownListContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7363816c-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.zIndices.dropdown;
}, function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, function(param) {
    var theme = param.theme;
    return theme.isDark ? "#fdb533" : "#fff";
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var DropDownContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7363816c-2"
})(_templateObject3(), function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(props) {
    return props.isOpen && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject2(), DropDownHeader, function(param) {
        var theme = param.theme;
        return theme.tooltip.boxShadow;
    }, DropDownListContainer, function(param) {
        var theme = param.theme;
        return theme.tooltip.boxShadow;
    });
});
var DropDownList = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-7363816c-3"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.zIndices.dropdown;
});
var ListItem = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    componentId: "sc-7363816c-4"
})(_templateObject5());
var Select = function(_param) {
    var options = _param.options, onOptionChange = _param.onOptionChange, _defaultOptionIndex = _param.defaultOptionIndex, defaultOptionIndex = _defaultOptionIndex === void 0 ? 0 : _defaultOptionIndex, placeHolderText = _param.placeHolderText, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "options",
        "onOptionChange",
        "defaultOptionIndex",
        "placeHolderText"
    ]);
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var dropdownRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), optionSelected = ref1[0], setOptionSelected = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(defaultOptionIndex), selectedOptionIndex = ref2[0], setSelectedOptionIndex = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        width: 0,
        height: 0
    }), containerSize = ref3[0], setContainerSize = ref3[1];
    var theme = (0,hooks_useTheme__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)().theme;
    var toggling = function(event) {
        if (options.length > 1) {
            setIsOpen(!isOpen);
        }
        event.stopPropagation();
    };
    var onOptionClicked = function(selectedIndex) {
        return function() {
            setSelectedOptionIndex(selectedIndex);
            setIsOpen(false);
            setOptionSelected(true);
            if (onOptionChange) {
                onOptionChange(options[selectedIndex]);
            }
        };
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setContainerSize({
            width: dropdownRef.current.offsetWidth,
            height: dropdownRef.current.offsetHeight
        });
        var handleClickOutside = function() {
            setIsOpen(false);
        };
        document.addEventListener("click", handleClickOutside);
        return function() {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (defaultOptionIndex) {
            setSelectedOptionIndex(defaultOptionIndex - 1);
            setOptionSelected(true);
        }
    }, [
        defaultOptionIndex
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(DropDownContainer, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        isOpen: isOpen
    }, props), {
        ref: containerRef
    }), containerSize), {
        children: [
            containerSize.width !== 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DropDownHeader, {
                onClick: toggling,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    color: !optionSelected && placeHolderText ? "text" : undefined,
                    children: !optionSelected && placeHolderText ? placeHolderText : options[selectedOptionIndex].label
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                color: theme.isDark ? "#fff" : "#000",
                onClick: toggling
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DropDownListContainer, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DropDownList, {
                    ref: dropdownRef,
                    children: options.map(function(option, index) {
                        return placeHolderText || index !== selectedOptionIndex ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomListItem, {
                            onClick: onOptionClicked(index),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                children: option.label
                            })
                        }, option.label) : null;
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Select);
var CustomListItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(ListItem).withConfig({
    componentId: "sc-7363816c-5"
})(_templateObject6());


/***/ }),

/***/ 24039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_marketplace; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 20 modules
var src = __webpack_require__(23474);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./src/components/Layout/PageHeader.tsx
var PageHeader = __webpack_require__(81904);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(63850);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 1 modules
var localization_src = __webpack_require__(68486);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./src/state/marketplace/index.ts
var marketplace = __webpack_require__(13190);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(62077);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(75943);
// EXTERNAL MODULE: ./src/components/Select/Select.tsx
var Select = __webpack_require__(76688);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/state/marketplace/actions.ts
var actions = __webpack_require__(11107);
// EXTERNAL MODULE: ./src/views/Marketplace/styles.ts
var styles = __webpack_require__(63612);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./src/state/multiBuyBox/hook/fetchdata.tsx
var fetchdata = __webpack_require__(37958);
// EXTERNAL MODULE: ./node_modules/react-paginate/dist/react-paginate.js
var react_paginate = __webpack_require__(11358);
var react_paginate_default = /*#__PURE__*/__webpack_require__.n(react_paginate);
// EXTERNAL MODULE: ./src/state/farms/hooks.ts + 3 modules
var hooks = __webpack_require__(44329);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/utils/renderBGCard.ts
var renderBGCard = __webpack_require__(15570);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/useGetBoxName.tsx
var useGetBoxName = __webpack_require__(87278);
;// CONCATENATED MODULE: ./src/views/Marketplace/components/ConditionCard.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width:100%;\n  justify-content:flex-end;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size:13px;\n  @media only screen and (max-width: 500px) {\n    font-size:13px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 348px;\n    height: 550px;\n    border-radius: 10px;\n    margin-bottom: 1rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    // cursor: pointer;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    height: 310px;\n    background:",
        ";\n    border-radius:8px;\n    position: relative;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 40px;\n    width: 40px;\n    border-radius:50%;\n    overflow:hidden;\n    position: absolute;\n    top:10px;\n    right:10px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: auto;\n    height: auto;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: rgba(48, 179, 140, 0.25);\n    border-radius: 6px;\n    width: 61px;\n    height: 32px;\n    padding:0px 10px 0px 10px;\n    justify-content: center;\n    align-items: center;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100px;\n    height: 32px;\n    border: 2px solid rgba(48, 179, 140, 0.25);\n    border-radius: 8px;\n    justify-content: center;\n    align-items: center;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 48px;\n    border: 2px solid #E6E8EC;\n    border-radius: 90px;\n    font-weight:bold;\n    font-size:18px;\n    background-color: transparent;\n    cursor: pointer;\n    color: #000;\n    &:hover{\n        background-color: #FF592C;\n        border: 2px solid #FF592C;\n        transition-duration:0.5s;\n        color:#fff;\n    }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}









var ConditionCard = function(param) {
    var nftId = param.nftId, saleId = param.saleId, nftType = param.nftType, price = param.price, seller = param.seller, isStore = param.isStore, runBusdPrice = param.runBusdPrice;
    var handleClick = function handleClick() {
        router.push("/detailbuy/".concat(saleId));
    };
    var router = (0,next_router.useRouter)();
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var boxName = (0,useGetBoxName/* GetBoxName */.J)(nftType.toString()).boxName;
    var sAccount = seller ? "".concat(seller.substring(0, 4), "...").concat(seller.substring(seller.length - 4)) : "";
    var link = "/detailbuy/".concat(saleId);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCard, {
                backgroundColor: (0,renderBGCard/* renderBGCard */.LO)(nftType),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgShoes, {
                    src: (0,renderBGCard/* renderImgBox */.II)(nftType),
                    alt: "Image Box"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                justifyContent: "space-between",
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    children: t("Run Together Box NFT")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                width: "100%",
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomId, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            bold: true,
                            children: [
                                "#",
                                nftId
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerBoxName, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            bold: true,
                            color: "#30B38C",
                            children: boxName
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                width: "100%",
                justifyContent: "space-between",
                mt: "5px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        bold: true,
                        fontSize: "18px",
                        children: t("Seller")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        bold: true,
                        mr: "5px",
                        children: sAccount
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                width: "100%",
                justifyContent: "space-between",
                mt: "1px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        bold: true,
                        fontSize: "18px",
                        children: t("Price")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                bold: true,
                                mr: "5px",
                                children: price.toLocaleString("en", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/images/coins/0xc643E83587818202E0fFf5eD96D10Abbc8Bb48e7.png",
                                alt: "logo runtogether",
                                style: {
                                    width: "30px",
                                    height: "30px"
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexCustom, {
                width: "100%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextCustom, {
                        mr: "5px",
                        children: [
                            "~$",
                            (price * runBusdPrice).toLocaleString("en", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: link,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomButton, {
                    children: t("Buy")
                })
            })
        ]
    });
};
/* harmony default export */ var components_ConditionCard = (ConditionCard);
var FlexCustom = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-4cad248e-0"
})(_templateObject());
var TextCustom = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-4cad248e-1"
})(_templateObject1());
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4cad248e-2"
})(_templateObject2());
var CustomCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4cad248e-3"
})(_templateObject3(), function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor;
});
var Tags = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-4cad248e-4"
})(_templateObject4());
var ImgShoes = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-4cad248e-5"
})(_templateObject5());
var CustomId = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-4cad248e-6"
})(_templateObject6());
var ContainerBoxName = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-4cad248e-7"
})(_templateObject7());
var Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4cad248e-8"
})(_templateObject8());
var CustomButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-4cad248e-9"
})(_templateObject9());

;// CONCATENATED MODULE: ./src/views/Marketplace/components/AdminCard.tsx

function AdminCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 348px;\n    height: 550px;\n    border-radius: 10px;\n    margin-bottom: 1rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    cursor: pointer;\n"
    ]);
    AdminCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AdminCard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    height: 310px;\n    border-radius:8px;\n    position: relative;\n"
    ]);
    AdminCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AdminCard_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: auto;\n    height: auto;\n"
    ]);
    AdminCard_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AdminCard_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-width: 150px;\n    height: 32px;\n    border: 2px solid rgba(48, 179, 140, 0.25);\n    border-radius: 8px;\n    justify-content: center;\n    align-items: center;\n"
    ]);
    AdminCard_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function AdminCard_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 48px;\n    border: 2px solid #E6E8EC;\n    border-radius: 90px;\n    font-weight:bold;\n    font-size:18px;\n    background-color: transparent;\n    cursor: pointer;\n    color: ",
        ";\n    &:hover{\n        background-color: #FF592C;\n        border: 2px solid #FF592C;\n        transition-duration:0.5s;\n        color:#fff;\n    }\n"
    ]);
    AdminCard_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function AdminCard_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-wrap: wrap;\n    justify-content: space-between;\n    gap: 5px;\n"
    ]);
    AdminCard_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






var CardAdmin = function(param) {
    var // eslint-disable-next-line @typescript-eslint/no-unused-vars
    nftSeller = param.nftSeller, boxName = param.boxName, totalNftInMarket = param.totalNftInMarket;
    var handleClick = function handleClick() {
        router.push("/cart");
    };
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdminCard_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminCard_CustomCard, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminCard_ImgShoes, {
                    src: "/images/runMarketplace/bg_multibox.png",
                    alt: "Image Box"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                justifyContent: "space-between",
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    children: t("Run Together Box NFT")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexNameBox, {
                children: boxName.length > 0 && boxName.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        justifyContent: "space-between",
                        alignItems: "center",
                        mt: "10px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminCard_ContainerBoxName, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "14px",
                                bold: true,
                                color: "textNameBox",
                                children: item.name
                            })
                        })
                    }, item);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                width: "100%",
                justifyContent: "space-between",
                mt: "10px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        bold: true,
                        fontSize: "18px",
                        children: t("Total quantity In stock")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        bold: true,
                        mr: "5px",
                        children: totalNftInMarket
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminCard_CustomButton, {
                onClick: handleClick,
                children: t("Buy")
            })
        ]
    });
};
/* harmony default export */ var AdminCard = (CardAdmin);
var AdminCard_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3885a932-0"
})(AdminCard_templateObject());
var AdminCard_CustomCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3885a932-1"
})(AdminCard_templateObject1());
var AdminCard_ImgShoes = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-3885a932-2"
})(AdminCard_templateObject2());
var AdminCard_ContainerBoxName = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-3885a932-3"
})(AdminCard_templateObject3());
var AdminCard_CustomButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-3885a932-4"
})(AdminCard_templateObject4(), function(props) {
    return props.theme.colors.text;
});
var FlexNameBox = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-3885a932-5"
})(AdminCard_templateObject5());

;// CONCATENATED MODULE: ./src/views/Marketplace/components/ContainerCardAll.tsx



function ContainerCardAll_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .pagination {\n    display: flex;\n    flex-direction: row;\n    width: 500px;\n    justify-content: space-around;\n    align-items: center;\n    @media screen and (max-width: 600px) {\n      width: 100%;\n    }\n    * {\n      list-style-type: none;\n    }\n  }\n  .page-link {\n    background: ",
        ";\n    padding: 12px;\n    border-radius: 5px !important;\n    border: none !important;\n    color: ",
        ";\n    &:focus {\n      box-shadow: none !important;\n    }\n    &:hover {\n      background: ",
        ";\n    }\n  }\n  .page-item.disabled .page-link {\n    background: ",
        ";\n    cursor: not-allowed !important;\n    opacity: 0.7;\n    pointer-events: none;\n  }\n  .page-item.active .page-link {\n    background: ",
        ";\n    color: #fff;\n  }\n  .pagination > li > a {\n    @media screen and (max-width: 600px) {\n      padding-left: 9px;\n      padding-right: 9px;\n      font-size: 13px;\n    }\n  }\n"
    ]);
    ContainerCardAll_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ContainerCardAll_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // width:100%;\n  flex-wrap: wrap;\n  justify-content: flex-start;  \n  column-gap: 52px;\n  @media screen and (min-width: 821px) and (max-width: 1024px) {\n    padding: 0px 50px 0px 50px;\n  }\n  @media screen and (max-width: 1024px) {\n    justify-content: space-between; \n    column-gap: 0px;\n  }\n  @media screen and (max-width: 600px) {\n    justify-content: space-around; \n    column-gap: 0px;\n  }\n"
    ]);
    ContainerCardAll_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}















var ContainerCard = function(param) {
    var listItems = param.listItems;
    var ChainShowCardAdmin = [
        src/* ChainId.BSC_TESTNET */.a_.BSC_TESTNET,
        src/* ChainId.ONUS_TESTNET */.a_.ONUS_TESTNET
    ];
    var isTabletOrMobile = (0,react_responsive.useMediaQuery)({
        query: "(max-width: 1024px)"
    });
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var runBusdPrice = (0,hooks/* usePriceRunBusd */.SD)().toNumber();
    var ref = (0,react.useState)(0), pageCount = ref[0], setPageCount = ref[1];
    var ref1 = (0,react.useState)(0), itemOffset = ref1[0], setItemOffset = ref1[1];
    var ref2 = (0,react.useState)((0,_to_consumable_array/* default */.Z)(listItems)), currentItems = ref2[0], setCurrentItems = ref2[1];
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var ref3;
    var isShowCardAdmin = (ref3 = ChainShowCardAdmin.find(function(e) {
        return e === chainId;
    })) !== null && ref3 !== void 0 ? ref3 : false;
    var itemsPerPage = itemOffset === 0 && isShowCardAdmin ? isTabletOrMobile ? 9 : 8 : isTabletOrMobile ? 10 : 9;
    // const itemsPerPage = itemOffset === 0 && isTestNet ? 8 : 9
    var ref4 = (0,react.useState)(0), initpagenumber = ref4[0], setInitPageNumber = ref4[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var valSelector = (0,es/* useSelector */.v9)(function(state) {
        return state.marketplace.pagenumbermkl;
    }) || 0;
    var dataAdmin = [
        {
            id: 1,
            name: "MetaRush"
        },
        {
            id: 2,
            name: "MetaRun"
        },
        {
            id: 3,
            name: "MetaRace"
        },
        {
            id: 4,
            name: "MetaRich"
        }, 
    ];
    var handlePageClick = function(event) {
        var newOffset = event.selected * itemsPerPage % listItems.length;
        setItemOffset(newOffset);
        dispatch((0,actions/* fetchNumberPageCurrent */.zf)({
            pagenumbermkl: event.selected
        }));
        setInitPageNumber(event.selected);
    };
    (0,react.useEffect)(function() {
        var endOffset = itemOffset + itemsPerPage;
        setCurrentItems(listItems.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(listItems.length / itemsPerPage));
    }, [
        itemOffset,
        itemsPerPage,
        listItems
    ]);
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,fetchdata/* GetBalanceNftInMarket */.Ln)(chainId), 1), nftBalance = ref5[0];
    var totalNftInMarket = nftBalance.totalNftMetaRace + nftBalance.totalNftMetaRich + nftBalance.totalNftMetaRun + nftBalance.totalNftMetaRush;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        width: "100%",
        flexDirection: "column",
        mt: "1rem",
        height: "auto",
        minHeight: "50vh",
        children: [
            totalNftInMarket === 0 && currentItems.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justifyContent: "space-around",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    children: t("No Data")
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: currentItems.length !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsFlex, {
                    children: [
                        itemOffset === 0 && isShowCardAdmin && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminCard, {
                            boxName: dataAdmin,
                            totalNftInMarket: totalNftInMarket
                        }),
                        currentItems.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ConditionCard, {
                                isStore: !false,
                                nftId: item.nftId,
                                saleId: item.saleId,
                                nftType: item.boxType,
                                price: item.priceListing,
                                seller: item.seller,
                                runBusdPrice: runBusdPrice
                            }, item.nftId);
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: itemOffset === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        justifyContent: "space-around",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: "No Data"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomFlex, {
                width: "100%",
                mt: "1rem",
                justifyContent: "center",
                height: "62px",
                children: currentItems.length !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)((react_paginate_default()), {
                    previousLabel: "<",
                    nextLabel: ">",
                    pageClassName: "page-item",
                    pageLinkClassName: "page-link",
                    previousClassName: "page-item",
                    previousLinkClassName: "page-link",
                    nextClassName: "page-item",
                    nextLinkClassName: "page-link",
                    breakLabel: "...",
                    breakClassName: "page-item",
                    breakLinkClassName: "page-link",
                    pageCount: pageCount,
                    marginPagesDisplayed: 2,
                    pageRangeDisplayed: 2,
                    onPageChange: handlePageClick,
                    containerClassName: "pagination",
                    activeClassName: "active",
                    initialPage: valSelector
                }) : ""
            })
        ]
    });
};
/* harmony default export */ var ContainerCardAll = (ContainerCard);
var CustomFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-2bd5f81c-0"
})(ContainerCardAll_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.tertiary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundTab;
}, function(param) {
    var theme = param.theme;
    return theme.colors.disabled;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primaryBright;
});
var CsFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-2bd5f81c-1"
})(ContainerCardAll_templateObject1());

;// CONCATENATED MODULE: ./src/views/Marketplace/components/ContainerMetaRush.tsx



function ContainerMetaRush_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .pagination {\n    display: flex;\n    flex-direction: row;\n    width: 500px;\n    justify-content: space-around;\n    align-items: center;\n    @media screen and (max-width: 600px) {\n      width: 100%;\n    }\n    * {\n      list-style-type: none;\n    }\n  }\n  .page-link {\n    background: ",
        ";\n    padding: 12px;\n    border-radius: 5px !important;\n    border: none !important;\n    color: ",
        ";\n    &:focus {\n      box-shadow: none !important;\n    }\n    &:hover {\n      background: ",
        ";\n    }\n  }\n  .page-item.disabled .page-link {\n    background: ",
        ";\n    cursor: not-allowed !important;\n    opacity: 0.7;\n    pointer-events: none;\n  }\n  .page-item.active .page-link {\n    background: ",
        ";\n    color: #fff;\n  }\n"
    ]);
    ContainerMetaRush_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ContainerMetaRush_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // width:100%;\n  flex-wrap: wrap;\n  justify-content: flex-start;  \n  column-gap: 52px;\n  @media screen and (min-width: 821px) and (max-width: 1024px) {\n    padding: 0px 50px 0px 50px;\n  }\n  @media screen and (max-width: 1024px) {\n    justify-content: space-between; \n    column-gap: 0px;\n  }\n  @media screen and (max-width: 600px) {\n    justify-content: space-around; \n    column-gap: 0px;\n  }\n"
    ]);
    ContainerMetaRush_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













var dataAdmin = [
    {
        id: 1,
        name: "MetaRush"
    },
    {
        id: 2,
        name: "MetaRun"
    },
    {
        id: 3,
        name: "MetaRace"
    },
    {
        id: 4,
        name: "MetaRich"
    }, 
];
var ContainerCardMetaRush = function(param) {
    var listItems = param.listItems;
    var ChainShowCardAdmin = [
        src/* ChainId.BSC_TESTNET */.a_.BSC_TESTNET,
        src/* ChainId.ONUS_TESTNET */.a_.ONUS_TESTNET
    ];
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var isTabletOrMobile = (0,react_responsive.useMediaQuery)({
        query: "(max-width: 1024px)"
    });
    var ref = (0,react.useState)(0), pageCount = ref[0], setPageCount = ref[1];
    var ref1 = (0,react.useState)(0), itemOffset = ref1[0], setItemOffset = ref1[1];
    var ref2 = (0,react.useState)((0,_to_consumable_array/* default */.Z)(listItems)), currentItems = ref2[0], setCurrentItems = ref2[1];
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var ref3;
    var isShowCardAdmin = (ref3 = ChainShowCardAdmin.find(function(e) {
        return e === chainId;
    })) !== null && ref3 !== void 0 ? ref3 : false;
    var itemsPerPage = itemOffset === 0 && isShowCardAdmin ? isTabletOrMobile ? 9 : 8 : isTabletOrMobile ? 10 : 9;
    var runBusdPrice = (0,hooks/* usePriceRunBusd */.SD)().toNumber();
    // panigate
    var handlePageClick = function(event) {
        var newOffset = event.selected * itemsPerPage % listItems.length;
        setItemOffset(newOffset);
    };
    (0,react.useEffect)(function() {
        var endOffset = itemOffset + itemsPerPage;
        setCurrentItems(listItems.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(listItems.length / itemsPerPage));
    }, [
        itemOffset,
        itemsPerPage,
        listItems
    ]);
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,fetchdata/* GetBalanceNftInMarket */.Ln)(chainId), 1), nftBalance = ref4[0];
    var totalNftInMarket = nftBalance.totalNftMetaRace + nftBalance.totalNftMetaRich + nftBalance.totalNftMetaRun + nftBalance.totalNftMetaRush;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        width: "100%",
        flexDirection: "column",
        mt: "1rem",
        height: "auto",
        minHeight: "50vh",
        children: [
            totalNftInMarket === 0 && currentItems.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justifyContent: "space-around",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    children: t("No Data")
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: currentItems.length !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerMetaRush_CsFlex, {
                    children: [
                        itemOffset === 0 && isShowCardAdmin && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminCard, {
                            boxName: dataAdmin,
                            totalNftInMarket: totalNftInMarket
                        }),
                        currentItems.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ConditionCard, {
                                isStore: !false,
                                nftId: item.nftId,
                                saleId: item.saleId,
                                nftType: item.boxType,
                                price: item.priceListing,
                                seller: item.seller,
                                runBusdPrice: runBusdPrice
                            }, item.nftId);
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    justifyContent: "space-around",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: t("No Data")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerMetaRush_CustomFlex, {
                width: "100%",
                mt: "1rem",
                justifyContent: "center",
                height: "62px",
                children: currentItems.length !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)((react_paginate_default()), {
                    previousLabel: "<",
                    nextLabel: ">",
                    pageClassName: "page-item",
                    pageLinkClassName: "page-link",
                    previousClassName: "page-item",
                    previousLinkClassName: "page-link",
                    nextClassName: "page-item",
                    nextLinkClassName: "page-link",
                    breakLabel: "...",
                    breakClassName: "page-item",
                    breakLinkClassName: "page-link",
                    pageCount: pageCount,
                    marginPagesDisplayed: 2,
                    pageRangeDisplayed: 5,
                    onPageChange: handlePageClick,
                    containerClassName: "pagination",
                    activeClassName: "active"
                }) : ""
            })
        ]
    });
};
/* harmony default export */ var ContainerMetaRush = (ContainerCardMetaRush);
var ContainerMetaRush_CustomFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-802c3a9-0"
})(ContainerMetaRush_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.tertiary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundTab;
}, function(param) {
    var theme = param.theme;
    return theme.colors.disabled;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primaryBright;
});
var ContainerMetaRush_CsFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-802c3a9-1"
})(ContainerMetaRush_templateObject1());

;// CONCATENATED MODULE: ./src/views/Marketplace/components/ContainerMetaRun.tsx



function ContainerMetaRun_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .pagination {\n    display: flex;\n    flex-direction: row;\n    width: 500px;\n    justify-content: space-around;\n    align-items: center;\n    @media screen and (max-width: 600px) {\n      width: 100%;\n    }\n    * {\n      list-style-type: none;\n    }\n  }\n  .page-link {\n    background: ",
        ";\n    padding: 12px;\n    border-radius: 5px !important;\n    border: none !important;\n    color: ",
        ";\n    &:focus {\n      box-shadow: none !important;\n    }\n    &:hover {\n      background: ",
        ";\n    }\n  }\n  .page-item.disabled .page-link {\n    background: ",
        ";\n    cursor: not-allowed !important;\n    opacity: 0.7;\n    pointer-events: none;\n  }\n  .page-item.active .page-link {\n    background: ",
        ";\n    color: #fff;\n  }\n"
    ]);
    ContainerMetaRun_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ContainerMetaRun_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // width:100%;\n  flex-wrap: wrap;\n  justify-content: flex-start;  \n  column-gap: 52px;\n  @media screen and (min-width: 821px) and (max-width: 1024px) {\n    padding: 0px 50px 0px 50px;\n  }\n  @media screen and (max-width: 1024px) {\n    justify-content: space-between; \n    column-gap: 0px;\n  }\n  @media screen and (max-width: 600px) {\n    justify-content: space-around; \n    column-gap: 0px;\n  }\n"
    ]);
    ContainerMetaRun_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













var ContainerMetaRun_dataAdmin = [
    {
        id: 1,
        name: "MetaRush"
    },
    {
        id: 2,
        name: "MetaRun"
    },
    {
        id: 3,
        name: "MetaRace"
    },
    {
        id: 4,
        name: "MetaRich"
    }, 
];
var ContainerCardMetaRun = function(param) {
    var listItems = param.listItems;
    var ChainShowCardAdmin = [
        src/* ChainId.BSC_TESTNET */.a_.BSC_TESTNET,
        src/* ChainId.ONUS_TESTNET */.a_.ONUS_TESTNET
    ];
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var isTabletOrMobile = (0,react_responsive.useMediaQuery)({
        query: "(max-width: 1024px)"
    });
    var ref = (0,react.useState)(0), pageCount = ref[0], setPageCount = ref[1];
    var ref1 = (0,react.useState)(0), itemOffset = ref1[0], setItemOffset = ref1[1];
    var ref2 = (0,react.useState)((0,_to_consumable_array/* default */.Z)(listItems)), currentItems = ref2[0], setCurrentItems = ref2[1];
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var ref3;
    var isShowCardAdmin = (ref3 = ChainShowCardAdmin.find(function(e) {
        return e === chainId;
    })) !== null && ref3 !== void 0 ? ref3 : false;
    var itemsPerPage = itemOffset === 0 && isShowCardAdmin ? isTabletOrMobile ? 9 : 8 : isTabletOrMobile ? 10 : 9;
    var runBusdPrice = (0,hooks/* usePriceRunBusd */.SD)().toNumber();
    // panigate
    var handlePageClick = function(event) {
        var newOffset = event.selected * itemsPerPage % listItems.length;
        setItemOffset(newOffset);
    };
    (0,react.useEffect)(function() {
        var endOffset = itemOffset + itemsPerPage;
        setCurrentItems(listItems.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(listItems.length / itemsPerPage));
    }, [
        itemOffset,
        itemsPerPage,
        listItems
    ]);
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,fetchdata/* GetBalanceNftInMarket */.Ln)(chainId), 1), nftBalance = ref4[0];
    var totalNftInMarket = nftBalance.totalNftMetaRace + nftBalance.totalNftMetaRich + nftBalance.totalNftMetaRun + nftBalance.totalNftMetaRush;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        width: "100%",
        flexDirection: "column",
        mt: "1rem",
        height: "auto",
        minHeight: "50vh",
        children: [
            totalNftInMarket === 0 && currentItems.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justifyContent: "space-around",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    children: t("No Data")
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: currentItems.length !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerMetaRun_CsFlex, {
                    children: [
                        itemOffset === 0 && isShowCardAdmin && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminCard, {
                            boxName: ContainerMetaRun_dataAdmin,
                            totalNftInMarket: totalNftInMarket
                        }),
                        currentItems.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ConditionCard, {
                                isStore: !false,
                                nftId: item.nftId,
                                saleId: item.saleId,
                                nftType: item.boxType,
                                price: item.priceListing,
                                seller: item.seller,
                                runBusdPrice: runBusdPrice
                            }, item.nftId);
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    justifyContent: "space-around",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: t("No Data")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerMetaRun_CustomFlex, {
                width: "100%",
                mt: "1rem",
                justifyContent: "center",
                height: "62px",
                children: currentItems.length !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)((react_paginate_default()), {
                    previousLabel: "<",
                    nextLabel: ">",
                    pageClassName: "page-item",
                    pageLinkClassName: "page-link",
                    previousClassName: "page-item",
                    previousLinkClassName: "page-link",
                    nextClassName: "page-item",
                    nextLinkClassName: "page-link",
                    breakLabel: "...",
                    breakClassName: "page-item",
                    breakLinkClassName: "page-link",
                    pageCount: pageCount,
                    marginPagesDisplayed: 2,
                    pageRangeDisplayed: 5,
                    onPageChange: handlePageClick,
                    containerClassName: "pagination",
                    activeClassName: "active"
                }) : ""
            })
        ]
    });
};
/* harmony default export */ var ContainerMetaRun = (ContainerCardMetaRun);
var ContainerMetaRun_CustomFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-740598b8-0"
})(ContainerMetaRun_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.tertiary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundTab;
}, function(param) {
    var theme = param.theme;
    return theme.colors.disabled;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primaryBright;
});
var ContainerMetaRun_CsFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-740598b8-1"
})(ContainerMetaRun_templateObject1());

;// CONCATENATED MODULE: ./src/views/Marketplace/components/ContainerMetaRace.tsx



function ContainerMetaRace_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .pagination {\n    display: flex;\n    flex-direction: row;\n    width: 500px;\n    justify-content: space-around;\n    align-items: center;\n    @media screen and (max-width: 600px) {\n      width: 100%;\n    }\n    * {\n      list-style-type: none;\n    }\n  }\n  .page-link {\n    background: ",
        ";\n    padding: 12px;\n    border-radius: 5px !important;\n    border: none !important;\n    color: ",
        ";\n    &:focus {\n      box-shadow: none !important;\n    }\n    &:hover {\n      background: ",
        ";\n    }\n  }\n  .page-item.disabled .page-link {\n    background: ",
        ";\n    cursor: not-allowed !important;\n    opacity: 0.7;\n    pointer-events: none;\n  }\n  .page-item.active .page-link {\n    background: ",
        ";\n    color: #fff;\n  }\n"
    ]);
    ContainerMetaRace_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ContainerMetaRace_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // width:100%;\n  flex-wrap: wrap;\n  justify-content: flex-start;  \n  column-gap: 52px;\n  @media screen and (min-width: 821px) and (max-width: 1024px) {\n    padding: 0px 50px 0px 50px;\n  }\n  @media screen and (max-width: 1024px) {\n    justify-content: space-between; \n    column-gap: 0px;\n  }\n  @media screen and (max-width: 600px) {\n    justify-content: space-around; \n    column-gap: 0px;\n  }\n"
    ]);
    ContainerMetaRace_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













var ContainerMetaRace_dataAdmin = [
    {
        id: 1,
        name: "MetaRush"
    },
    {
        id: 2,
        name: "MetaRun"
    },
    {
        id: 3,
        name: "MetaRace"
    },
    {
        id: 4,
        name: "MetaRich"
    }, 
];
var ContainerCardMetaRace = function(param) {
    var listItems = param.listItems;
    var ChainShowCardAdmin = [
        src/* ChainId.BSC_TESTNET */.a_.BSC_TESTNET,
        src/* ChainId.ONUS_TESTNET */.a_.ONUS_TESTNET
    ];
    var isTabletOrMobile = (0,react_responsive.useMediaQuery)({
        query: "(max-width: 1024px)"
    });
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(0), pageCount = ref[0], setPageCount = ref[1];
    var ref1 = (0,react.useState)(0), itemOffset = ref1[0], setItemOffset = ref1[1];
    var ref2 = (0,react.useState)((0,_to_consumable_array/* default */.Z)(listItems)), currentItems = ref2[0], setCurrentItems = ref2[1];
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var ref3;
    var isShowCardAdmin = (ref3 = ChainShowCardAdmin.find(function(e) {
        return e === chainId;
    })) !== null && ref3 !== void 0 ? ref3 : false;
    var itemsPerPage = itemOffset === 0 && isShowCardAdmin ? isTabletOrMobile ? 9 : 8 : isTabletOrMobile ? 10 : 9;
    var runBusdPrice = (0,hooks/* usePriceRunBusd */.SD)().toNumber();
    // panigate
    var handlePageClick = function(event) {
        var newOffset = event.selected * itemsPerPage % listItems.length;
        setItemOffset(newOffset);
    };
    (0,react.useEffect)(function() {
        var endOffset = itemOffset + itemsPerPage;
        setCurrentItems(listItems.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(listItems.length / itemsPerPage));
    }, [
        itemOffset,
        itemsPerPage,
        listItems
    ]);
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,fetchdata/* GetBalanceNftInMarket */.Ln)(chainId), 1), nftBalance = ref4[0];
    var totalNftInMarket = nftBalance.totalNftMetaRace + nftBalance.totalNftMetaRich + nftBalance.totalNftMetaRun + nftBalance.totalNftMetaRush;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        width: "100%",
        flexDirection: "column",
        mt: "1rem",
        height: "auto",
        minHeight: "50vh",
        children: [
            totalNftInMarket === 0 && currentItems.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justifyContent: "space-around",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    children: t("No Data")
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: currentItems.length !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerMetaRace_CsFlex, {
                    children: [
                        itemOffset === 0 && isShowCardAdmin && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminCard, {
                            boxName: ContainerMetaRace_dataAdmin,
                            totalNftInMarket: totalNftInMarket
                        }),
                        currentItems.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ConditionCard, {
                                isStore: !false,
                                nftId: item.nftId,
                                saleId: item.saleId,
                                nftType: item.boxType,
                                price: item.priceListing,
                                seller: item.seller,
                                runBusdPrice: runBusdPrice
                            }, item.nftId);
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    justifyContent: "space-around",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: t("No Data")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerMetaRace_CustomFlex, {
                width: "100%",
                mt: "1rem",
                justifyContent: "center",
                height: "62px",
                children: currentItems.length !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)((react_paginate_default()), {
                    previousLabel: "<",
                    nextLabel: ">",
                    pageClassName: "page-item",
                    pageLinkClassName: "page-link",
                    previousClassName: "page-item",
                    previousLinkClassName: "page-link",
                    nextClassName: "page-item",
                    nextLinkClassName: "page-link",
                    breakLabel: "...",
                    breakClassName: "page-item",
                    breakLinkClassName: "page-link",
                    pageCount: pageCount,
                    marginPagesDisplayed: 2,
                    pageRangeDisplayed: 5,
                    onPageChange: handlePageClick,
                    containerClassName: "pagination",
                    activeClassName: "active"
                }) : ""
            })
        ]
    });
};
/* harmony default export */ var ContainerMetaRace = (ContainerCardMetaRace);
var ContainerMetaRace_CustomFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-68f273b1-0"
})(ContainerMetaRace_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.tertiary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundTab;
}, function(param) {
    var theme = param.theme;
    return theme.colors.disabled;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primaryBright;
});
var ContainerMetaRace_CsFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-68f273b1-1"
})(ContainerMetaRace_templateObject1());

;// CONCATENATED MODULE: ./src/views/Marketplace/components/ContainerCardMetaRich.tsx



function ContainerCardMetaRich_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .pagination {\n    display: flex;\n    flex-direction: row;\n    width: 500px;\n    justify-content: space-around;\n    align-items: center;\n    @media screen and (max-width: 600px) {\n      width: 100%;\n    }\n    * {\n      list-style-type: none;\n    }\n  }\n  .page-link {\n    background: ",
        ";\n    padding: 12px;\n    border-radius: 5px !important;\n    border: none !important;\n    color: ",
        ";\n    &:focus {\n      box-shadow: none !important;\n    }\n    &:hover {\n      background: ",
        ";\n    }\n  }\n  .page-item.disabled .page-link {\n    background: ",
        ";\n    cursor: not-allowed !important;\n    opacity: 0.7;\n    pointer-events: none;\n  }\n  .page-item.active .page-link {\n    background: ",
        ";\n    color: #fff;\n  }\n"
    ]);
    ContainerCardMetaRich_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ContainerCardMetaRich_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // width:100%;\n  flex-wrap: wrap;\n  justify-content: flex-start;  \n  column-gap: 52px;\n  @media screen and (min-width: 821px) and (max-width: 1024px) {\n    padding: 0px 50px 0px 50px;\n  }\n  @media screen and (max-width: 1024px) {\n    justify-content: space-between; \n    column-gap: 0px;\n  }\n  @media screen and (max-width: 600px) {\n    justify-content: space-around; \n    column-gap: 0px;\n  }\n"
    ]);
    ContainerCardMetaRich_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












var ContainerCardMetaRich_dataAdmin = [
    {
        id: 1,
        name: "MetaRush"
    },
    {
        id: 2,
        name: "MetaRun"
    },
    {
        id: 3,
        name: "MetaRace"
    },
    {
        id: 4,
        name: "MetaRich"
    }, 
];
var ContainerCardMetaRich = function(param) {
    var listItems = param.listItems;
    var ChainShowCardAdmin = [
        src/* ChainId.BSC_TESTNET */.a_.BSC_TESTNET,
        src/* ChainId.ONUS_TESTNET */.a_.ONUS_TESTNET
    ];
    var isTabletOrMobile = (0,react_responsive.useMediaQuery)({
        query: "(max-width: 1024px)"
    });
    var ref = (0,react.useState)(0), pageCount = ref[0], setPageCount = ref[1];
    var ref1 = (0,react.useState)(0), itemOffset = ref1[0], setItemOffset = ref1[1];
    var ref2 = (0,react.useState)((0,_to_consumable_array/* default */.Z)(listItems)), currentItems = ref2[0], setCurrentItems = ref2[1];
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var ref3;
    var isShowCardAdmin = (ref3 = ChainShowCardAdmin.find(function(e) {
        return e === chainId;
    })) !== null && ref3 !== void 0 ? ref3 : false;
    var itemsPerPage = itemOffset === 0 && isShowCardAdmin ? isTabletOrMobile ? 9 : 8 : isTabletOrMobile ? 10 : 9;
    var runBusdPrice = (0,hooks/* usePriceRunBusd */.SD)().toNumber();
    // panigate
    var handlePageClick = function(event) {
        var newOffset = event.selected * itemsPerPage % listItems.length;
        setItemOffset(newOffset);
    };
    (0,react.useEffect)(function() {
        var endOffset = itemOffset + itemsPerPage;
        setCurrentItems(listItems.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(listItems.length / itemsPerPage));
    }, [
        itemOffset,
        itemsPerPage,
        listItems
    ]);
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,fetchdata/* GetBalanceNftInMarket */.Ln)(chainId), 1), nftBalance = ref4[0];
    var totalNftInMarket = nftBalance.totalNftMetaRace + nftBalance.totalNftMetaRich + nftBalance.totalNftMetaRun + nftBalance.totalNftMetaRush;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        width: "100%",
        flexDirection: "column",
        mt: "1rem",
        height: "auto",
        minHeight: "50vh",
        children: [
            totalNftInMarket === 0 && currentItems.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justifyContent: "space-around",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    children: "No Data"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: currentItems.length !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerCardMetaRich_CsFlex, {
                    children: [
                        itemOffset === 0 && isShowCardAdmin && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminCard, {
                            boxName: ContainerCardMetaRich_dataAdmin,
                            totalNftInMarket: totalNftInMarket
                        }),
                        currentItems.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ConditionCard, {
                                isStore: !false,
                                nftId: item.nftId,
                                saleId: item.saleId,
                                nftType: item.boxType,
                                price: item.priceListing,
                                seller: item.seller,
                                runBusdPrice: runBusdPrice
                            }, item.nftId);
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    justifyContent: "space-around",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: "No Data"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerCardMetaRich_CustomFlex, {
                width: "100%",
                mt: "1rem",
                justifyContent: "center",
                height: "62px",
                children: currentItems.length !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)((react_paginate_default()), {
                    previousLabel: "<",
                    nextLabel: ">",
                    pageClassName: "page-item",
                    pageLinkClassName: "page-link",
                    previousClassName: "page-item",
                    previousLinkClassName: "page-link",
                    nextClassName: "page-item",
                    nextLinkClassName: "page-link",
                    breakLabel: "...",
                    breakClassName: "page-item",
                    breakLinkClassName: "page-link",
                    pageCount: pageCount,
                    marginPagesDisplayed: 2,
                    pageRangeDisplayed: 5,
                    onPageChange: handlePageClick,
                    containerClassName: "pagination",
                    activeClassName: "active"
                }) : ""
            })
        ]
    });
};
/* harmony default export */ var components_ContainerCardMetaRich = (ContainerCardMetaRich);
var ContainerCardMetaRich_CustomFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-e5d86fdd-0"
})(ContainerCardMetaRich_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.tertiary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundTab;
}, function(param) {
    var theme = param.theme;
    return theme.colors.disabled;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primaryBright;
});
var ContainerCardMetaRich_CsFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-e5d86fdd-1"
})(ContainerCardMetaRich_templateObject1());

;// CONCATENATED MODULE: ./src/views/Marketplace/components/BOXESSTORE.tsx












var BOXESSTORE_dataAdmin = [
    {
        id: 1,
        name: "MetaRush"
    },
    {
        id: 2,
        name: "MetaRun"
    },
    {
        id: 3,
        name: "MetaRace"
    },
    {
        id: 4,
        name: "MetaRich"
    }, 
];
var BOXESSTORE = function(param) {
    var sortprice = param.sortprice, filterBoxType = param.filterBoxType;
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var ref = (0,_sliced_to_array/* default */.Z)((0,marketplace/* GetTotalSellItems */.Ab)(chainId), 1), totalSell = ref[0];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,marketplace/* GetListItems */.GW)(totalSell, chainId), 1), listItems = ref1[0];
    var ref2 = (0,react.useState)([]), listNftItem = ref2[0], setListNftItem = ref2[1];
    (0,react.useEffect)(function() {
        var object = (0,_to_consumable_array/* default */.Z)(listItems);
        if (sortprice === "highest") {
            if (filterBoxType !== 0) {
                return setListNftItem(object.sort(function(obj1, obj2) {
                    return Number(obj2.priceListing) - Number(obj1.priceListing);
                }).filter(function(data) {
                    return data.boxType === filterBoxType;
                }));
            }
            return setListNftItem(object.sort(function(obj1, obj2) {
                return Number(obj2.priceListing) - Number(obj1.priceListing);
            }));
        }
        if (sortprice === "lowest") {
            if (filterBoxType !== 0) {
                return setListNftItem(object.sort(function(obj1, obj2) {
                    return Number(obj1.priceListing) - Number(obj2.priceListing);
                }).filter(function(data) {
                    return data.boxType === filterBoxType;
                }));
            }
            return setListNftItem(object.sort(function(obj1, obj2) {
                return Number(obj1.priceListing) - Number(obj2.priceListing);
            }));
        }
        return setListNftItem((0,_to_consumable_array/* default */.Z)(listItems));
    }, [
        sortprice,
        filterBoxType,
        listItems
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        width: "100%",
        flexDirection: "column",
        mt: "1rem",
        height: "auto",
        minHeight: "50vh",
        children: [
            filterBoxType === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerCardAll, {
                listItems: listNftItem
            }),
            filterBoxType === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerMetaRush, {
                listItems: listNftItem
            }),
            filterBoxType === 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerMetaRun, {
                listItems: listNftItem
            }),
            filterBoxType === 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerMetaRace, {
                listItems: listNftItem
            }),
            filterBoxType === 4 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ContainerCardMetaRich, {
                listItems: listNftItem
            })
        ]
    });
};
/* harmony default export */ var components_BOXESSTORE = (BOXESSTORE);

;// CONCATENATED MODULE: ./src/views/Marketplace/Marketplace.tsx















var Marketplace = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var valSelector = (0,es/* useSelector */.v9)(function(state) {
        return state.marketplace.listsortprice;
    });
    var ref = (0,react.useState)("highest"), sortprice = ref[0], setSortprice = ref[1];
    var datamapoption = [
        {
            label: "Highest to lowest",
            value: "highest"
        },
        {
            label: "Lowest to highest",
            value: "lowest"
        }
    ];
    var datamapoption2 = [
        {
            label: "Lowest to highest",
            value: "lowest"
        },
        {
            label: "Highest to lowest",
            value: "highest"
        }
    ];
    var ref1 = (0,react.useState)(datamapoption), valuedatamap = ref1[0], setValueDataMap = ref1[1];
    var ref2 = (0,react.useState)(1), defaultindex = ref2[0], setDefaultIndex = ref2[1];
    var ref3 = (0,react.useState)(0), activeIndex = ref3[0], setActiveIndex = ref3[1];
    var itemsPerPage = 9;
    var ref4 = (0,react.useState)(0), pageCount = ref4[0], setPageCount = ref4[1];
    var ref5 = (0,react.useState)(0), itemOffset = ref5[0], setItemOffset = ref5[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleSortOptionPrice = function(option) {
        var valuedispatch = {
            labelsort: option.label,
            valuesort: option.value
        };
        dispatch((0,actions/* fetchValueSortPrice */.rU)({
            listsortprice: valuedispatch
        }));
        setSortprice(option.value);
        if (option.value === "highest") {
            setSortprice("highest");
            setValueDataMap(datamapoption);
            setDefaultIndex(1);
        }
        if (option.value === "lowest") {
            setSortprice("lowest");
            setValueDataMap(datamapoption2);
            setDefaultIndex(2);
        }
    };
    (0,react.useEffect)(function() {
        if (valSelector.valuesort === "highest") {
            setSortprice("highest");
            setValueDataMap(datamapoption);
            setDefaultIndex(1);
        }
        if (valSelector.valuesort === "lowest") {
            setSortprice("lowest");
            setValueDataMap(datamapoption2);
            setDefaultIndex(2);
        }
    }, [
        valSelector,
        dispatch
    ]);
    // console.log('valSelector',valueselector)
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,marketplace/* GetTotalSellItems */.Ab)(chainId), 1), totalSell = ref6[0];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,marketplace/* GetListItems */.GW)(totalSell, chainId), 1), listItems = ref7[0];
    var ref8 = (0,react.useState)((0,_to_consumable_array/* default */.Z)(listItems)), currentItems = ref8[0], setCurrentItems = ref8[1];
    var ref9 = (0,react.useState)((0,_to_consumable_array/* default */.Z)(listItems)), listNftItem = ref9[0], setListNftItem = ref9[1];
    // sort
    (0,react.useEffect)(function() {
        var SortPrice = function SortPrice() {
            if (sortprice === "highest") {
                return setListNftItem(object.sort(function(obj1, obj2) {
                    return Number(obj2.priceListing) - Number(obj1.priceListing);
                }));
            }
            if (sortprice === "lowest") {
                return setListNftItem(object.sort(function(obj1, obj2) {
                    return Number(obj1.priceListing) - Number(obj2.priceListing);
                }));
            }
        };
        var object = (0,_to_consumable_array/* default */.Z)(listItems);
        if (listItems.length !== 0) {
            SortPrice();
        }
    }, [
        sortprice,
        listItems
    ]);
    // getsum
    var getSumBoxType = function(type) {
        var sumType = 0;
        if ((listItems === null || listItems === void 0 ? void 0 : listItems.length) > 0) {
            if (type > 0) {
                var ref;
                sumType = (ref = listItems.filter(function(item) {
                    return item.boxType === type;
                })) === null || ref === void 0 ? void 0 : ref.length;
            } else {
                sumType = listItems.length;
            }
        }
        return sumType;
    };
    (0,react.useEffect)(function() {
        var endOffset = itemOffset + itemsPerPage;
        setCurrentItems(listNftItem.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(listNftItem.length / itemsPerPage));
    }, [
        itemOffset,
        itemsPerPage,
        listNftItem,
        sortprice
    ]);
    (0,react.useEffect)(function() {
        setItemOffset(0);
    }, [
        sortprice
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                nameTitle: "RUN TOGETHER",
                namePlace: "Marketplace",
                imgIcon: "/images/runMarketplace/imgBanner.png",
                bgColor: theme.colors.pink
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* CustomPage */.Xx, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ContainerMenu */.xI, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Wrapper */.im, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ContainerTabButton */.c, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* CustomButton */.op, {
                                            isActive: activeIndex === 0 ? !false : false,
                                            onClick: function() {
                                                return setActiveIndex(0);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* TextCustom */.e4, {
                                                ml: "5px",
                                                color: "textDisabled",
                                                bold: true,
                                                children: [
                                                    t("All"),
                                                    " (",
                                                    getSumBoxType(0),
                                                    ")"
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* CustomButton */.op, {
                                        isActive: activeIndex === 1 ? !false : false,
                                        onClick: function() {
                                            return setActiveIndex(1);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Tags */.$G, {
                                                src: "/images/martketplace/11.png",
                                                alt: "tag box"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* TextCustom */.e4, {
                                                ml: "5px",
                                                color: "textDisabled",
                                                bold: true,
                                                children: [
                                                    t("MetaRush"),
                                                    " (",
                                                    getSumBoxType(1),
                                                    ")"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* CustomButton */.op, {
                                        isActive: activeIndex === 2 ? !false : false,
                                        onClick: function() {
                                            return setActiveIndex(2);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Tags */.$G, {
                                                src: "/images/martketplace/22.png",
                                                alt: "tag box"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* TextCustom */.e4, {
                                                ml: "5px",
                                                color: "textDisabled",
                                                bold: true,
                                                children: [
                                                    t("MetaRun"),
                                                    " (",
                                                    getSumBoxType(2),
                                                    ")"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* CustomButton */.op, {
                                        isActive: activeIndex === 3 ? !false : false,
                                        onClick: function() {
                                            return setActiveIndex(3);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Tags */.$G, {
                                                src: "/images/martketplace/33.png",
                                                alt: "tag box"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* TextCustom */.e4, {
                                                ml: "5px",
                                                color: "textDisabled",
                                                bold: true,
                                                children: [
                                                    t("MetaRace"),
                                                    " (",
                                                    getSumBoxType(3),
                                                    ")"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* CustomButton */.op, {
                                        isActive: activeIndex === 4 ? !false : false,
                                        onClick: function() {
                                            return setActiveIndex(4);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Tags */.$G, {
                                                src: "/images/martketplace/44.png",
                                                alt: "tag box"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* TextCustom */.e4, {
                                                ml: "5px",
                                                color: "textDisabled",
                                                bold: true,
                                                children: [
                                                    t("MetaRich"),
                                                    " (",
                                                    getSumBoxType(4),
                                                    ")"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* FlexPrice */.XL, {
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        textTransform: "uppercase",
                                        color: "textDisabled",
                                        mr: "10px",
                                        children: t("Price")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                        options: datamapoption,
                                        onOptionChange: handleSortOptionPrice,
                                        defaultOptionIndex: defaultindex
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Container */.W2, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            width: "100%",
                            flexWrap: "wrap",
                            justifyContent: "space-around",
                            alignItems: "center",
                            minHeight: "50vh",
                            mt: "1.25rem",
                            mb: "1.25rem",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BOXESSTORE, {
                                sortprice: sortprice,
                                filterBoxType: activeIndex
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Marketplace_Marketplace = (Marketplace);

;// CONCATENATED MODULE: ./src/views/Marketplace/index.tsx



var MarketplaceLayout = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Marketplace_Marketplace, {
        children: children
    });
};

;// CONCATENATED MODULE: ./src/pages/marketplace/index.tsx




var MarketplacePage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketplaceLayout, {})
    });
};
MarketplacePage.Layout = MarketplaceLayout;
MarketplacePage.chains = [
    src/* ChainId.BSC */.a_.BSC,
    src/* ChainId.BSC_TESTNET */.a_.BSC_TESTNET
];
/* harmony default export */ var pages_marketplace = (MarketplacePage);


/***/ }),

/***/ 63612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ Tags; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "XL": function() { return /* binding */ FlexPrice; },
/* harmony export */   "Xx": function() { return /* binding */ CustomPage; },
/* harmony export */   "c": function() { return /* binding */ ContainerTabButton; },
/* harmony export */   "e4": function() { return /* binding */ TextCustom; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "op": function() { return /* binding */ CustomButton; },
/* harmony export */   "xI": function() { return /* binding */ ContainerMenu; }
/* harmony export */ });
/* unused harmony exports CustomInputGroup, CustomFlex, Row, CustomTab */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94406);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75943);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62077);
/* harmony import */ var components_Layout_Page__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75915);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(186);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @media only screen and (max-width: 1350px) {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n  @media only screen and (max-width: 600px) {\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 231px;\n  border-radius: 5px;\n  height: 100%;\n  @media only screen and (max-width: 600px) {\n    width: 200px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .pagination {\n    display: flex;\n    flex-direction: row;\n    width: 340px;\n    justify-content: space-around;\n    align-items: center;\n    * {\n      list-style-type: none;\n    }\n  }\n  .page-link {\n    background: ",
        ";\n    padding: 12px;\n    border-radius: 5px !important;\n    border: none !important;\n    color: ",
        ";\n    &:focus {\n      box-shadow: none !important;\n    }\n    &:hover {\n      background: ",
        ";\n    }\n  }\n  .page-item.disabled .page-link {\n    background: ",
        ";\n    cursor: not-allowed !important;\n    opacity: 0.7;\n    pointer-events: none;\n  }\n  .page-item.active .page-link {\n    background: ",
        ";\n    color: #fff;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @media only screen and (max-width: 815px) {\n    font-size:12px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height:60px;\n  width: auto;\n  padding:0px 10px 0px 10px;\n  border-bottom: ",
        ";\n  font-weight:bold;\n  color:#777E91;\n  padding-bottom:10px;\n  display: flex;\n  align-items: center;\n  cursor:pointer;\n  @media only screen and (max-width: 600px) {\n    width: 50%;\n    justify-content: flex-start;\n    margin-bottom:1rem;\n    &:first-child {\n      justify-content: center;\n      \n    }\n  }\n  @media screen and (max-width: 320px) {\n    padding: 0px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    height: 35px;\n    width: 35px;\n    border-radius:50%;\n    overflow:hidden;\n\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top:1.25rem;\n  width:100%;\n  justify-content: space-between;\n  flex-wrap:wrap-reverse;\n  @media only screen and (max-width: 600px) {\n    justify-content:flex-end;\n    padding-right:10px;\n    ",
        "{\n      width: 100%;\n      justify-content: flex-start;\n      margin-top:1rem;\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 50%;\n    height:50px;\n    display:flex;\n    font-weight:bold;\n    cursor:pointer;\n    justify-content: center;\n    align-items: center;\n    color:",
        ";\n    border-bottom:",
        "; \n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  gap: 50px;\n  @media only screen and (max-width: 1149px) {\n    padding-left: 10px;\n  }\n  @media screen and (max-width: 600px) {\n    gap: 14px;\n  } \n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    margin-top:1.25rem;\n    width:100%;\n    justify-content: space-between;\n    flex-wrap:wrap-reverse;\n    @media only screen and (max-width: 600px) {\n      justify-content:flex-end;\n      padding-right:10px;\n      ",
        "{\n        width: 100%;\n        justify-content: flex-start;\n        margin-top:1rem;\n      }\n    }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: auto;\n    @media only screen and (max-width: 600px) {\n       width: 100%;\n       justify-content: center !important;\n       align-items: center !important;\n    }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    flex-wrap:wrap;\n    @media only screen and (max-width: 1149px) {\n      width: 100%;\n      justify-content: space-between;\n      margin-top: 20px;\n    }\n    @media only screen and (max-width: 815px) {\n      flex-wrap: nowrap;\n    }\n    @media only screen and (max-width: 600px) {\n      flex-wrap:wrap;\n    }\n    @media only screen and (min-width: 600px) and (max-width: 1080px) {\n       width: 100%;\n       margin-top:10px;\n       justify-content:space-between;\n    }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}



var CustomPage = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(components_Layout_Page__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-857d377d-0"
})(_templateObject());
var Container = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-857d377d-1"
})(_templateObject1());
var CustomInputGroup = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-857d377d-2"
})(_templateObject2());
var CustomFlex = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-857d377d-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.tertiary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundTab;
}, function(param) {
    var theme = param.theme;
    return theme.colors.disabled;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primaryBright;
});
var TextCustom = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-857d377d-4"
})(_templateObject4());
var CustomButton = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-857d377d-5"
})(_templateObject5(), function(param) {
    var isActive = param.isActive;
    return isActive ? "3px solid #4B19F5" : "none";
});
var Tags = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-857d377d-6"
})(_templateObject6());
var Row = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-857d377d-7"
})(_templateObject7(), _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);
var CustomTab = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-857d377d-8"
})(_templateObject8(), function(param) {
    var isActive = param.isActive;
    return isActive ? "#4B19F5" : "#B1B5C3";
}, function(param) {
    var isActive = param.isActive;
    return isActive ? "3px solid #4B19F5" : "none";
});
var FlexPrice = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-857d377d-9"
})(_templateObject9());
var ContainerMenu = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(Row).withConfig({
    componentId: "sc-857d377d-10"
})(_templateObject10(), _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);
var ContainerTabButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-857d377d-11"
})(_templateObject11());
var Wrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-857d377d-12"
})(_templateObject12());


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1852,1827,7958,9774,2888,179], function() { return __webpack_exec__(31709); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);